import { Target, Eye } from "lucide-react";

const MissionVisionSection = () => {
    return (
        <section className="mission-vision-section">
            <div className="container">
                <div className="d-flex flex-wrap gap-8 justify-content-center">

                    {/* MISIÓN */}
                    <div>
                        <div className="card border-0 shadow-sm h-100 mission-card" style={{ maxWidth: '500px' }}>
                            <div className="card-body p-10 text-start">

                                <div className="icon-box mb-5">
                                    <Target size={32} color="white" />
                                </div>

                                <h5 className="fw-bold mb-2 fs-1">Misión</h5>

                                <p className="fs-6 mb-0">
                                    En <strong style={{ color: '#d22222' }}>Talara Rent a Car</strong> brindamos un servicio confiable de alquiler de autos
                                    y camionetas en Talara, ofreciendo vehículos modernos, seguros y en excelente estado para garantizar la mejor experiencia
                                    de movilidad en el norte del Perú.
                                    <br />
                                    <br />
                                    Nuestro compromiso es atender las necesidades de turistas, profesionales y empresas que visitan la ciudad,
                                    proporcionando soluciones de rent a car en Talara con atención personalizada, procesos rápidos y altos estándares de calidad,
                                    para que cada viaje se realice con comodidad, seguridad y total confianza.
                                </p>

                            </div>
                        </div>
                    </div>

                    {/* VISIÓN */}
                    <div>
                        <div className="card border-0 shadow-sm h-100 mission-card" style={{ maxWidth: '500px' }}>
                            <div className="card-body p-10 text-start">

                                <div className="icon-box mb-5">
                                    <Eye size={32} color="white" />
                                </div>

                                <h5 className="fw-bold mb-2 fs-1">Visión</h5>

                                <p className="fs-6 mb-0">
                                    Ser la empresa referente de alquiler de autos en Talara y en el norte del Perú, reconocida por brindar 
                                    un servicio de rent a car seguro, confiable y de alta calidad. Aspiramos a diferenciarnos por nuestra 
                                    atención personalizada, una flota moderna y variada de vehículos, y precios competitivos que se adapten 
                                    a las necesidades de cada cliente.
                                    <br />
                                    <br />
                                    En <strong style={{ color: '#d22222' }}>Talara Rent a Car</strong> buscamos consolidarnos como la primera opción para turistas, profesionales y empresas 
                                    que requieren soluciones de movilidad en la región, garantizando siempre una experiencia de viaje cómoda, 
                                    segura y eficiente.
                                </p>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <style>
                {`
        .mission-vision-section{
          background:#f4eded;
          padding: 8rem 0;
        }

        .mission-card{
          border-radius:12px;
        }

        .icon-box{
          width:50px;
          height:50px;
          display:flex;
          align-items:center;
          justify-content:center;
          background:#d22222;
          border-radius:8px;
        }

        .mission-card p{
          font-size:0.95rem;
          line-height:1.6;
        }
        `}
            </style>
        </section>
    );
};

export default MissionVisionSection;